export default function () {
  controller('faq-area', self => {
    const trigger = $('.js-faq-trigger');

    trigger.on('click', e =>{
      e.preventDefault();
      
      let self = $(e.currentTarget);
      
      self.closest('.faq-area__item').find('.faq-area__drop').slideToggle(200);
    })

  });
}
